const config = require('../../../../config/locales_json/packs/public_company/contact.json');
const language = $('body').data("language");

(function($) {
    'use strict';
    
    jQuery("document").ready(function() {
        $("#contact_select_type").on("change", function(){
            var typeContact = $(this).val();
            // Si es estudiante
            if(typeContact == "0"){
                $("#form-student").removeClass("hidden")
                $("#form-company").addClass("hidden")
            } else {
                $("#form-student").addClass("hidden")
                $("#form-company").removeClass("hidden")
            }
        })

        $("#contact_form #btn_sent").on("click", function(e){
            e.preventDefault();
            var error = 0;
            var typeContact = $("#contact_select_type").val();

            // Si es estudiante
            if(typeContact == "0"){
                var studentFullName = $("#contact_student_name")
                var studentEmail = $("#contact_student_email")
                var studentPhone = $("#contact_student_phone")
                var studentMessage = $("#contact_student_message")

                if(studentFullName.val().trim().length == 0) {
                    studentFullName.addClass("error-form")
                    error++;
                } else {
                    studentFullName.removeClass("error-form")
                }

                if(studentEmail.val().trim().length == 0) {
                    studentEmail.addClass("error-form")
                    error++;
                } else {
                    studentEmail.removeClass("error-form")
                }

                if(studentPhone.val().trim().length == 0) {
                    studentPhone.addClass("error-form")
                    error++;
                } else {
                    studentPhone.removeClass("error-form")
                }

                if(studentMessage.val().trim().length == 0) {
                    studentMessage.addClass("error-form")
                    error++;
                } else {
                    studentMessage.removeClass("error-form")
                }

            } else {
                var clientFullName = $("#contact_client_name")
                var clientPosition = $("#contact_client_position")
                var clientCompany = $("#contact_client_company")
                var clientCountry = $("#contact_client_country")
                var clientEmail = $("#contact_client_email")
                var clientPhone = $("#contact_client_phone")
                var clientMessage = $("#contact_client_message")

                if(clientFullName.val().trim().length == 0) {
                    clientFullName.addClass("error-form")
                    error++;
                } else {
                    clientFullName.removeClass("error-form")
                }

                if(clientPosition.val().trim().length == 0) {
                    clientPosition.addClass("error-form")
                    error++;
                } else {
                    clientPosition.removeClass("error-form")
                }

                if(clientCompany.val().trim().length == 0) {
                    clientCompany.addClass("error-form")
                    error++;
                } else {
                    clientCompany.removeClass("error-form")
                }

                if(clientCountry.val().trim().length == 0) {
                    clientCountry.addClass("error-form")
                    error++;
                } else {
                    clientCountry.removeClass("error-form")
                }

                if(clientEmail.val().trim().length == 0) {
                    clientEmail.addClass("error-form")
                    error++;
                } else {
                    clientEmail.removeClass("error-form")
                }

                if(clientPhone.val().trim().length == 0) {
                    clientPhone.addClass("error-form")
                    error++;
                } else {
                    clientPhone.removeClass("error-form")
                }

                if(clientMessage.val().trim().length == 0) {
                    clientMessage.addClass("error-form")
                    error++;
                } else {
                    clientMessage.removeClass("error-form")
                }
            }
            
            if (!error && $("#btn_sent").data("checked")){
                const successText = getTranslationValue(config, [language, "not_error_text"], "ENVIANDO...");

                $(this).addClass("disabled")
                $(this).text(successText)
                $("#contact_form").submit()
            } 
            else if (!$("#btn_sent").data("checked")){
                const alertText = getTranslationValue(config, [language, "recaptcha_error"], "Debe completar el recaptcha");

                alert(alertText);
            }
            else {
                const alertText = getTranslationValue(config, [language, "alert_text"], "Debe completar todos los campos");
                alert(alertText);
            }
        })

        $("#partner_form #partner_handle_jobs").on("change", function(){
            var selectedOptionDataVal = $(this).find('option:selected').data("val");
            var partnerJobsWeb = $("#partner_jobs_web");
            var partnerJobsWebContainer = partnerJobsWeb.parent();

            if(selectedOptionDataVal == "1"){
                partnerJobsWebContainer.removeClass("d-none");
                partnerJobsWeb.removeAttr("disabled");
                partnerJobsWeb.attr("required", true);
            } else {
                partnerJobsWebContainer.addClass("d-none");
                partnerJobsWeb.attr("disabled", true);
                partnerJobsWeb.removeAttr("required");
            }
        })

        $("#partner_form #btn_sent").on("click", function(e){
            e.preventDefault();
            var error = 0;

            var partnerFullName = $("#partner_name")
            var partnerEmail = $("#partner_email")
            var partnerClientCompany = $("#partner_client_company")
            var partnerHandleJobs = $("#partner_handle_jobs")
            var partnerHandleJobsSelectedOptionDataVal = partnerHandleJobs.find('option:selected');
            var partnerJobsWeb = $("#partner_jobs_web")
            var partnerClientCountry = $("#partner_client_country")

            const emailRegex = /\b[\w+\-.]+@[a-z\d\-.]+\.[a-z]+\b/
            const emailVal = partnerEmail.val().trim();

            const urlRegex = /^(https?|http?):\/\/[^\s/$.?#].[^\s]*$/
            const urlVal = partnerJobsWeb.val().trim();

            if(partnerFullName.val().trim().length == 0) {
                partnerFullName.addClass("error-form")
                error++;
            } else {
                partnerFullName.removeClass("error-form")
            }

            if(emailVal.length == 0 || !emailRegex.test(emailVal)) {
                partnerEmail.addClass("error-form")
                error++;
            } else {
                partnerEmail.removeClass("error-form")
            }

            if(partnerClientCompany.val().trim().length == 0) {
                partnerClientCompany.addClass("error-form")
                error++;
            } else {
                partnerClientCompany.removeClass("error-form")
            }

            if(!partnerHandleJobs.val()) {
                partnerHandleJobs.addClass("error-form")
                error++;
            } else {
                partnerHandleJobs.removeClass("error-form")
            }

            if(urlVal.length > 0 && !urlRegex.test(urlVal)) {
                partnerJobsWeb.addClass("error-form")
                error++;
            } else {
                partnerJobsWeb.removeClass("error-form")
            }

            if (partnerHandleJobsSelectedOptionDataVal.length > 0 && partnerHandleJobsSelectedOptionDataVal.data("val") == "1") {
                if (!urlVal || !urlRegex.test(urlVal)) {
                    partnerJobsWeb.addClass("error-form")
                    error++;
                } else {
                    partnerJobsWeb.removeClass("error-form")
                }
            }

            if(!partnerClientCountry.val()) {
                partnerClientCountry.addClass("error-form")
                error++;
            } else {
                partnerClientCountry.removeClass("error-form")
            }
            
            if (!error && $("#btn_sent").data("checked")){
                const successText = getTranslationValue(config, [language, "not_error_text"], "ENVIANDO...");

                $(this).addClass("disabled")
                $(this).text(successText)
                $("#partner_form").submit()
            } 
            else if (!$("#btn_sent").data("checked")){
                const alertText = getTranslationValue(config, [language, "recaptcha_error"], "Debe completar el recaptcha");
                alert(alertText);
            }
            else {
                const alertText = getTranslationValue(config, [language, "alert_text"], "Debe completar todos los campos");
                alert(alertText);
            }
        })
    })
}(jQuery));

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}